import React from 'react'
import { makeStyles, Grid } from '@material-ui/core'
import UserForm from './UserForm'

const useStyles = makeStyles((_theme) => ({

}))

export default function ManageUserScreen(props) {
  const classes = useStyles()

  return (
    <Grid container justify="center">
      <Grid item xs={ 12 } md={ 6 }>
        <UserForm />
      </Grid>
    </Grid>
  )
}
